import BlockImage from './BlockImage';

export default BlockImage;
